<template>
  <b-container fluid>
    <slot></slot>

    <div class="tabs-row mb-3">
      <b-button
        v-for="tab in tabs"
        :key="tab.key"
        variant="light"
        class="tab-button"
        :class="{ active: activeTab === tab.key }"
        @click="activeTab = tab.key"
      >
        <font-awesome-icon :icon="tab.icon" fixed-width />
        <span class="fs-title">{{ tab.label }}</span>
      </b-button>
    </div>

    <b-row>
      <b-col cols="12">
        <transition name="fade" mode="out-in">
          <ResourceCard
            :key="activeTab"
            :items="links[activeTab] || []"
            @openLink="$emit('openLink', $event)"
          />
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ResourceCard from './ResourceCard'
export default {
  name: 'SaludOcupacionalSection',
  props: {
    links: {
      type: Object,
      required: true
    }
  },
  components: {
    ResourceCard
  },
  data () {
    return {
      activeTab: 1,
      tabs: [
        { key: 1, label: 'FORMULARIOS', icon: ['far', 'file-alt'] }
      ]
    }
  },
  computed: {
    currentTab () {
      return this.tabs.find(tab => tab.key === this.activeTab)
    },
    currentTabLabel () {
      return this.currentTab ? this.currentTab.label : ''
    },
    currentTabIcon () {
      return this.currentTab ? this.currentTab.icon : ['far', 'file-alt']
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-title {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .fs-title {
    font-weight: bold;
    font-size: 0.8rem;
    margin-left: 0.4rem;
  }
  @media (min-width: 1513px) {
    .fs-title {
      font-size: 0.9rem;
    }
  }

  .tabs-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .tab-button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    min-width: 160px;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    color: #6c757d;
    transition: all 0.2s ease;

    &:hover:not(.active) {
      background-color: #eaeaea;
      color: #163D7D;
      border-color: #cccccc;
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(22, 61, 125, 0.15);
    }

    &.active {
      background-color: #163D7D !important;
      border-color: #163D7D !important;
      color: white !important;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
